export default __webpack_public_path__ + "static/media/undef_icon.3e3f2532.svg";